import isElectron from 'is-electron';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { CommunicationMessageTypes, LessonControlMessage } from '../helpers/constants';
import { resetExecutorState_Ac } from '../store/actions/executor.actions';
import { IControlMessage, isLessonControlMessage } from '../types/communicator-types';
import useCommunicator from './useCommunicator';

interface LessonReplayPayload {
  system: string;
  unit: string;
  version: string;
  mode: string;
  role: string;
  token: string;
  tct?: string;
  enrollId?: string;
  subjectId?: string;
  attemptType?: string;
}

export default function useLessonReplay(
  payload: LessonReplayPayload,
  handleReset: () => void
) {
  const {
    system,
    unit,
    version,
    mode,
    role,
    token,
    tct = 'false',
    enrollId,
    subjectId,
    attemptType = 'training',
  } = payload;
  const dispatch = useDispatch();
  const history = useHistory();
  const communicator = useCommunicator<IControlMessage>(
    CommunicationMessageTypes.ControlMessage
  );
  useEffect(() => {
    communicator?.receiveMessage((msg) => {
      if (
        isLessonControlMessage(msg) &&
        msg.controlMessage === LessonControlMessage.REPLAY_LESSON
      ) {
        handleReset();
        dispatch(resetExecutorState_Ac());
        (window as any).reloadPage = true;
        setTimeout(() => {
          if (isElectron() && window.NotsElectron) {
            // if this is electron environment, then we need to tell electron to reload
            window.NotsElectron.send('replay-player', {
              system: system,
              trainingUnitId: unit,
              versionId: version,
              mode,
              role,
              token,
              tct,
              enrollId,
              subjectId,
              attemptType,
            });
          } else {
            history.push(`/login${history.location.search}`);
          }
        }, 100);
      }
    });
  }, [communicator]);
  return {};
}
